import { render } from "./legoCheckboxExtend.vue?vue&type=template&id=fd705916&scoped=true"
import script from "./legoCheckboxExtend.vue?vue&type=script&lang=js"
export * from "./legoCheckboxExtend.vue?vue&type=script&lang=js"

import "./legoCheckboxExtend.vue?vue&type=style&index=0&id=fd705916&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd705916"],['__file',"src/components/lego/extend/legoCheckboxExtend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd705916"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd705916', __exports__)) {
    api.reload('fd705916', __exports__)
  }
  
  module.hot.accept("./legoCheckboxExtend.vue?vue&type=template&id=fd705916&scoped=true", () => {
    api.rerender('fd705916', render)
  })

}


export default __exports__